<app-tdo-progress-spinner *ngIf="isLoading" data-cy="medical-history-spinner"></app-tdo-progress-spinner>
<div fxLayoutGap class="medical-container" style="overflow: auto" *ngIf="!isLoading" data-cy="medical-history-container">
  <div fxLayout="column" style="flex: 1; height: 100%; margin: 6px" data-cy="medical-history-header-section">
    <div fxLayout="row">
      <h5 style="text-align: start; display: inline; flex:1" data-cy="medical-history-title">Patient Medical and Medication History  </h5>
<!--      <h5 style="text-align: end; display: inline; flex:1">{{patientName}}</h5>-->
    </div>
<!--    <div fxLayout="row">-->
<!--      <span style="text-align: end; display: inline; flex:1" *ngIf="patients.length > 1">-->
<!--        <mat-label>Change Patient: </mat-label>-->
<!--        <mat-select [placeholder]="'Select Another Patient'" style="max-width: 200px; font-size: 14px">-->
<!--          <mat-option *ngFor="let pat of patients" [value]="pat?.PatientId" (click)="changePatient(pat?.PatientId)">-->
<!--            {{pat?.dataContact.LastName}}, {{pat?.dataContact.FirstName}}-->
<!--          </mat-option>-->
<!--        </mat-select>-->
<!--      </span>-->

<!--      <span style="text-align: end; display: inline; flex:1" *ngIf="patients.length < 1">-->
<!--        <mat-label>Change Patient: </mat-label>-->
<!--        <mat-select [placeholder]="'Loading Patients, Please wait'" style="max-width: 200px; font-size: 14px">-->
<!--          <mat-option>-->
<!--            Loading Patients, Please wait-->
<!--          </mat-option>-->
<!--        </mat-select>-->
<!--      </span>-->
<!--    </div>-->
  </div>

  <div style="display: flex; flex: 1; overflow: hidden; max-height: 100%" data-cy="medical-history-content">
    <div fxLayout="column" style="flex: 1; height: 100%">
      <div fxLayout="column" class="content">
        <div fxLayout="column" class="section-1" data-cy="medical-history-medication-section">
          <mat-label data-cy="medical-history-medication-label">Medication History</mat-label>
          <div fxLayout="row" class="label" style="color: black" data-cy="medical-history-medication-headers">
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-medication-header">Medication</div>
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-quantity-header">Quantity</div>
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-frequency-header">Frequency</div>
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-startdate-header">Start Date</div>
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-reason-header">Reason</div>
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-enddate-header">End Date</div>
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-stopped-header">Stopped Taking?</div>
          </div>
          <div data-cy="medical-history-medication-list">
            <div fxLayout="row wrap">
              <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-medication-names">
                <div fxLayout="row" style="width: 100%" *ngFor="let med of formData?.medicationHistoryResults" data-cy="medical-history-medication-name">
                  {{med.ItemName === 'resMRXMedication' ? med.Result : ''}}
                </div>
              </div>
              <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-medication-quantities">
                <div style="width: 100%" *ngFor="let med of formData?.medicationHistoryResults" data-cy="medical-history-medication-quantity">
                  {{med.ItemName === 'resMRXQuantity' ? med.Result : '' }}
                </div>
              </div>
              <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-medication-frequencies">
                <div style="width: 100%" *ngFor="let med of formData?.medicationHistoryResults" data-cy="medical-history-medication-frequency">
                  {{med.ItemName === 'resMRXFrequency' ? med.Result : ''}}
                </div>
              </div>
              <div fxLayout="column"  style="flex:1; height: 100%" data-cy="medical-history-medication-startdates">
                <div fxLayout="row" style="width: 100%" *ngFor="let med of formData?.medicationHistoryResults" data-cy="medical-history-medication-startdate">
                  {{med.ItemName === 'resMRXStartDate' ? med.Result : ''}}
                </div>
              </div>
              <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-medication-reasons">
                <div style="width: 100%" *ngFor="let med of formData?.medicationHistoryResults" data-cy="medical-history-medication-reason">
                  {{med.ItemName === 'resMRXReason' ? med.Result : ''}}
                </div>
              </div>
              <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-medication-enddates">
                <div style="width: 100%" *ngFor="let med of formData?.medicationHistoryResults" data-cy="medical-history-medication-enddate">
                  {{med.ItemName === 'resMRXLastTaken' ? med.Result : ''}}
                </div>
              </div>
              <div fxLayout="column"  style="flex:1; height: 100%" data-cy="medical-history-medication-stopped-statuses">
                <div style="width: 100%" *ngFor="let med of formData?.medicationHistoryResults" data-cy="medical-history-medication-stopped-status">
                  <span *ngIf="med.ItemName === 'resMRXStppedTagingIt'">
                        {{med.Result === 'd1906d4a-89e6-4c07-adb6-11c154b22766' ? 'No' : 'Yes'}}
                    </span>
                </div>
              </div>
            </div>
          </div>
          <div fxLayout="row" *ngIf="formData?.medicationHistoryResults === null" data-cy="medical-history-no-medication-message">
            <div fxLayout="column" style="flex:1; height: 100%; text-align: center;"><i>No Medication For This Patient</i></div>
          </div>
        </div>
      </div>

      <div fxLayout="column" class="content">
        <div fxLayout="column" class="section-1" data-cy="medical-history-rx-section">
          <mat-label data-cy="medical-history-rx-label">Rx History</mat-label>
          <tdo-table #prescriptionTable *ngIf="!isLoading  && prescriptions"
                     [dataSource]="prescriptions" [isSearchable]="false" data-cy="medical-history-rx-table">
            <tdo-table-column displayName="Reference" propertyName="reference" isSortable="true"
                              [rowTemplate]="reference" data-cy="medical-history-rx-reference-column">
              <ng-template #reference let-row>
                <div style="max-width: 100px;" data-cy="medical-history-rx-reference-value">
                  {{row.model?.reference.split(' ')[0]}}
                </div>
                <div style="max-width: 150px" *ngIf="row.model.reference?.trim() === ''" data-cy="medical-history-rx-reference-general">
                  General
                  <!--          <button mat-raised-button-->
                  <!--                  color="primary" class="tdox-btn bg-danger mt-2"-->
                  <!--                  (click)="onFixPrescription(row.model)">-->
                  <!--            Change-->
                  <!--          </button>-->
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Date" propertyName="date" isSortable="true" [rowTemplate]="date" data-cy="medical-history-rx-date-column">
              <ng-template #date let-row>
                <div style="max-width: 180px;" data-cy="medical-history-rx-date-value">
                  {{row.model?.prescriptionDate.format('MM/DD/YY')}}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Dispense" propertyName="dispenseUnit" [rowTemplate]="dispense" data-cy="medical-history-rx-dispense-column">
              <ng-template #dispense let-row>
                <div style="max-width: 160px; text-align: center" data-cy="medical-history-rx-dispense-value">
                  {{row.model?.dispenseQuantity}} {{row.model.dispenseUnit}}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Medication" propertyName="medication" isSortable="true"
                              [rowTemplate]="medication" data-cy="medical-history-rx-medication-column">
              <ng-template #medication let-row>
                <div style="max-width: 160px; text-align: center" data-cy="medical-history-rx-medication-value">
                  {{row.model?.medication}}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Dosage" propertyName="dosage" isSortable="false" [rowTemplate]="dosage" data-cy="medical-history-rx-dosage-column">
              <ng-template #dosage let-row>
                <div style="max-width: 160px;" data-cy="medical-history-rx-dosage-value">
                  {{row.model?.dosage}} {{row.model.dosageForm}}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Directions" propertyName="directions" isSortable="false"
                              [rowTemplate]="directions" data-cy="medical-history-rx-directions-column">
              <ng-template #directions let-row>
                <div style="max-width: 300px;" data-cy="medical-history-rx-directions-value">
                  {{row.model?.directions}}
                </div>
              </ng-template>
            </tdo-table-column>
<!--            <tdo-table-column displayName="Refill" propertyName="refill" isSortable="false" [rowTemplate]="refill">-->
<!--              <ng-template #refill let-row>-->
<!--                <div style="max-width: 160px;">-->
<!--                  {{row.model?.refill}}-->
<!--                </div>-->
<!--              </ng-template>-->
<!--            </tdo-table-column>-->
            <tdo-table-column displayName="Prescriber" propertyName="doctorName" isSortable="true" [rowTemplate]="doctor" data-cy="medical-history-rx-prescriber-column">
              <ng-template #doctor let-row>
                <div style="max-width: 160px;" data-cy="medical-history-rx-prescriber-value">
                  <u class="text-primary pointer">{{row.model?.doctorName}}</u>
                  <!--            (click)="onDoctorClicked(row.model.doctorID)"-->
                </div>
              </ng-template>
            </tdo-table-column>
<!--            <tdo-table-column displayName="Pharmacy" propertyName="pharmacy" isSortable="true" [rowTemplate]="pharmacy">-->
<!--              <ng-template #pharmacy let-row>-->
<!--                <div style="max-width: 160px;">-->
<!--                  <u class="text-primary pointer"-->
<!--                     >{{row.model?.pharmacyName}}</u>-->
<!--                </div>-->
<!--              </ng-template>-->
<!--            </tdo-table-column>-->
<!--            <tdo-table-column displayName="Pharm #" propertyName="pharmacyPhoneNumber" isSortable="false"-->
<!--                              [rowTemplate]="pharmacyphone">-->
<!--              <ng-template #pharmacyphone let-row>-->
<!--                <div style="max-width: 160px;">-->
<!--                  <u><a [href]="'tel:' + row.model?.pharmacyPhoneNumber">{{row.model?.pharmacyPhoneNumber}}</a></u>-->
<!--                  <span *ngIf="row.model.pharmacyPhoneNumber === '' || !row.model.pharmacyPhoneNumber ">not avail</span>-->
<!--                </div>-->
<!--              </ng-template>-->
<!--            </tdo-table-column>-->
            <!--      <tdo-table-column displayName="Details" propertyName="details" isSortable="true" [rowTemplate]="details">-->
            <!--        <ng-template #details let-row>-->
            <!--          <div style="max-width: 160px;">-->
            <!--&lt;!&ndash;            <button mat-raised-button color="primary" class="tdox-btn"&ndash;&gt;-->
            <!--&lt;!&ndash;             >            </button>&ndash;&gt;-->

            <!--            <mat-icon svgIcon="info" color="primary" class="tdox-btn" (click)="onDetailsClicked(row.model)"></mat-icon>-->
            <!--          </div>-->
            <!--        </ng-template>-->
            <!--      </tdo-table-column>-->
          </tdo-table>
          <div fxLayout="row" *ngIf="!prescriptions" data-cy="medical-history-no-rx-message">
            <div fxLayout="column" style="flex:1; height: 100%; text-align: center;"><i>No Prescriptions For This Patient</i></div>
          </div>
        </div>
      </div>

      <div fxLayout="column" class="content" >
        <div fxLayout="column" class="section-2" style="overflow: auto" data-cy="medical-history-problems-section">
          <mat-label data-cy="medical-history-problems-label">Medical History</mat-label>
          <div fxLayout="row" class="label" style=" color: black" data-cy="medical-history-problems-headers">
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-problem-header">Problem</div>
            <div fxLayout="column" style="flex:1; height: 100%" data-cy="medical-history-patient-note-header">Patient Note</div>
<!--            <div fxLayout="column" style="flex:1; height: 100%">Doctor Note</div>-->
          </div>
          <div fxLayout="row" *ngIf="formData.medicalHistoryResults === null" data-cy="medical-history-no-problems-message">
            <div fxLayout="column" style="flex:1; height: 100%; text-align: center;"><i>No History For This Patient</i></div>
          </div>
          <div fxLayout="row" *ngFor="let his of formData.medicalHistoryResults" data-cy="medical-history-problem-item">
            <div fxLayout="column" style="flex:1; height: 100%" *ngIf="his.patientNote !== 'd1906d4a-89e6-4c07-adb6-11c154b22766'" data-cy="medical-history-problem-name">
              {{his?.problem}}
            </div>
            <div fxLayout="column" style="flex:1; height: 100%"
            *ngIf="his.patientNote !== 'd1906d4a-89e6-4c07-adb6-11c154b22766' && his.patientNote !== '00000888-1000-0000-0000-000000000002'
              && his.patientNote !== '4d4900ea-3114-4121-af9c-3c9c57eb4d54'" data-cy="medical-history-problem-note">
              {{his.patientNote}}
            </div>
            <div fxLayout="column" style="flex:1; height: 100%"
                 *ngIf="his.patientNote === '00000888-1000-0000-0000-000000000002' || his.patientNote === '4d4900ea-3114-4121-af9c-3c9c57eb4d54'" data-cy="medical-history-problem-yes">
              Yes
            </div>
<!--            <div fxLayout="column" style="flex:1; height: 100%">{{doctorNote}}</div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
